import React from 'react'
import { cn } from '@/utils/cn'

type LogoSize = 'sm' | 'md' | 'lg' | 'full' | 'login'

interface ArTechLogoProps {
  size?: LogoSize
  showText?: boolean    // kept for API compatibility — PNG already contains the text
  showTagline?: boolean // kept for API compatibility
  className?: string
}

const heights: Record<LogoSize, number> = {
  sm:    22,   // small footer / badge use
  md:    44,   // sidebar header
  lg:   110,   // login page hero — large enough to read wheel + text clearly
  full:  60,
  login: 68,   // login card header — prominent branding above "Welcome back"
}

export function ArTechLogo({
  size = 'md',
  className,
}: ArTechLogoProps) {
  return (
    <img
      src="/artechlogo.png"
      alt="AR Tech Solutions"
      style={{ height: heights[size], width: 'auto' }}
      className={cn('flex-shrink-0 object-contain', className)}
      draggable={false}
    />
  )
}

export default ArTechLogo
